import {
  TREE_SIDE_API_FATHER,
  TREE_SIDE_API_MOTHER,
} from "./subscriptionAccess";

/**
 * Same key as `Layout/header.jsx` — which family side row the user is viewing (matches `family_side` from GET /my-family-trees).
 */
export const HEADER_PREFERRED_FAMILY_SIDE_KEY = "header_preferred_family_side";

/** Session: member completed the "Select family" modal (see Layout/header.jsx). */
export const SELECT_FAMILY_SIDE_MODAL_DONE_SESSION_KEY =
  "select_family_side_modal_done";

/** Session: which account last saw the family modal logic (logout clears). */
export const FAMILY_SIDE_MODAL_SESSION_USER_ID_KEY =
  "fam_connect_family_modal_session_uid";

/** Normalize API/header `family_side` or storage to `mother` | `father` | "". */
export function normalizeFamilySideKey(s) {
  if (s == null || s === "") return "";
  const t = String(s).trim().toLowerCase().replace(/\s+/g, "");
  if (t === "mother" || t === "motherside") return "mother";
  if (t === "father" || t === "fatherside") return "father";
  return "";
}

/**
 * Reads `header_preferred_family_side` only (no tree `id` required).
 * When set to mother or father, import is fixed to that line; the other line is hidden in the UI.
 *
 * @returns {{ apiSide: string | null, locked: boolean, visibleSides: "both" | "mother" | "father" }}
 */
export function getImportTreeSideStateFromHeaderPreference() {
  let preferredRaw = "";
  try {
    preferredRaw = (
      localStorage.getItem(HEADER_PREFERRED_FAMILY_SIDE_KEY) || ""
    ).trim();
  } catch {
    preferredRaw = "";
  }
  const prefKey = normalizeFamilySideKey(preferredRaw);
  if (!prefKey) {
    return { apiSide: null, locked: false, visibleSides: "both" };
  }
  const apiSide =
    prefKey === "mother" ? TREE_SIDE_API_MOTHER : TREE_SIDE_API_FATHER;
  return {
    apiSide,
    locked: true,
    visibleSides: prefKey,
  };
}
